import { getCurrentConfig } from '../config/environments';

// API Configuration - Dynamic based on environment
export const API_BASE_URL = getCurrentConfig().apiBaseUrl;


// API Endpoints
export const API_ENDPOINTS = {
  CUSTOMERS: '/customers.php',
  ORDERS: '/orders.php',
  MEASUREMENTS: '/measurements.php',
  STITCH_ITEMS: '/stitch_items.php',
  DASHBOARD: '/dashboard.php',
  PAYMENTS: '/payments.php',
  SHOP_SETTINGS: '/shop_settings.php',
  SUBSCRIPTIONS: '/subscriptions.php',
};

// Order Status Options
export const ORDER_STATUS = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  DELIVERED: 'delivered',
  CANCELLED: 'cancelled',
} as const;

// Payment Methods
export const PAYMENT_METHODS = {
  CASH: 'cash',
  CARD: 'card',
  UPI: 'upi',
  BANK_TRANSFER: 'bank_transfer',
} as const;

// Payment Types
export const PAYMENT_TYPES = {
  ADVANCE: 'advance',
  BALANCE: 'balance',
  FULL: 'full',
} as const;

// Default Measurements for Different Clothing Types
export const DEFAULT_MEASUREMENTS = {
  SHIRT: [
    'Chest', 'Waist', 'Length', 'Shoulder', 'Sleeve Length', 'Sleeve Width', 'Neck', 'Armhole'
  ],
  PANT: [
    'Waist', 'Hip', 'Length', 'Thigh', 'Knee', 'Bottom', 'Crotch', 'Inseam'
  ],
  COAT: [
    'Chest', 'Waist', 'Length', 'Shoulder', 'Sleeve Length', 'Sleeve Width', 'Neck', 'Armhole', 'Back Length'
  ],
  DUPATTA: [
    'Length', 'Width'
  ],
  BLOUSE: [
    'Chest', 'Waist', 'Length', 'Shoulder', 'Sleeve Length', 'Sleeve Width', 'Neck', 'Armhole'
  ],
  KURTA: [
    'Chest', 'Waist', 'Length', 'Shoulder', 'Sleeve Length', 'Sleeve Width', 'Neck', 'Armhole'
  ],
  SALWAR: [
    'Waist', 'Hip', 'Length', 'Thigh', 'Knee', 'Bottom', 'Crotch', 'Inseam'
  ],
  SUIT: [
    'Chest', 'Waist', 'Length', 'Shoulder', 'Sleeve Length', 'Sleeve Width', 'Neck', 'Armhole', 'Back Length'
  ],
};

// App Configuration
export const APP_CONFIG = {
  SHOP_NAME: 'TailorStitchPro Tailoring',
  CURRENCY: '₹',
  TAX_RATE: 0,
  INVOICE_PREFIX: 'TSP',
};

// Local Storage Keys
export const STORAGE_KEYS = {
  CURRENT_ORDER: 'tailorstitchpro_current_order',
  SELECTED_CUSTOMER: 'tailorstitchpro_selected_customer',
  USER_PREFERENCES: 'tailorstitchpro_user_preferences',
}; 